import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import * as Sentry from "@sentry/react";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const CVE_RE = /^CVE-\d{4}-\d{4,7}$/i;
const INT_RE = /^\d+$/;

export function normaliseRoute(path: string): string {
  if (!path) return "/";
  const segments = path.split("/");
  const normalised = segments.map((seg) => {
    if (UUID_RE.test(seg)) return ":id";
    if (CVE_RE.test(seg)) return ":cve";
    if (INT_RE.test(seg)) return ":id";
    return seg;
  });
  return normalised.join("/") || "/";
}

export function useSentryRouteTag(): void {
  const location = useLocation();
  useEffect(() => {
    Sentry.setTag("route", normaliseRoute(location.pathname));
  }, [location.pathname]);
}
